import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative min-h-[85vh] flex items-center pt-20 overflow-hidden" data-id="element-160">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/jdjiPRMGqiMEU3qR3tKpmR/pexels-40037226-7667625.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-161">
        <div className="absolute inset-0 bg-charcoal/70 mix-blend-multiply" data-id="element-162" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/40 to-transparent" data-id="element-163" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20" data-id="element-164">
        <motion.div className="max-w-3xl" variants={containerVariants} initial="hidden" animate="visible" data-id="element-165">
          <motion.h1 variants={itemVariants} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 tracking-tight" data-id="element-166">
            Kingsbury Maintenance & Construction
          </motion.h1>

          <motion.p variants={itemVariants} className="text-xl sm:text-2xl text-white/90 font-medium mb-4 max-w-2xl" data-id="element-167">
            Your Trusted Partner for Residential & Commercial Projects, Repairs
            and Maintenance
          </motion.p>

          <motion.p variants={itemVariants} className="text-base sm:text-lg text-white/70 mb-10 max-w-2xl leading-relaxed" data-id="element-168">
            We identify issues, plan solutions, and execute high-quality repairs
            to keep your business running smoothly.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-169">
            <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-white bg-primary hover:bg-primary-light transition-colors rounded-md shadow-lg" data-id="element-170">
              Request a Quote
            </a>
            <a href="#services" onClick={e => scrollToSection(e, '#services')} className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-white border border-white/30 hover:bg-white/10 transition-colors rounded-md backdrop-blur-sm" data-id="element-171">
              Our Services
            </a>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-center gap-2 text-white/60 text-sm" data-id="element-172">
            <MapPinIcon className="w-4 h-4 text-primary" data-id="element-173" />
            <span data-id="element-174">
              Based in Toronto, Ontario | Serving the Greater Toronto Area
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}